var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"copyright"},[_c('p',[_c('i',[_vm._v("©miahabib "+_vm._s(this.currentYear)+" - "),_c('span',{staticClass:"contact",on:{"click":_vm.contact}},[_vm._v("contact")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }